import { useModalMeta } from "@/shared/atoms/useModal";
import usePrint from "@/shared/hooks/usePrint";
import useSchedulePrintMutation from "@/shared/mutations/schedules/useSchedulePrintMutation";
import { formatDate } from "@/shared/utils/helpers";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Button from "../Button/Button";
import Textfield from "../Input/Textfield";
import Modal, { ModalProps } from "../Modal/Modal";

const SchedulesPrintModal = ({ onExit, ...props }: ModalProps) => {
  const print = usePrint();
  const getPrintDoc = useSchedulePrintMutation();
  const [meta] = useModalMeta();
  const { start_date_and_time, end_date_and_time } = meta;
  const { t } = useTranslation("");
  const { register, errors, handleSubmit } = useForm({
    defaultValues: {
      start_date_and_time: formatDate(start_date_and_time, "dateTimeLocal"),
      end_date_and_time: formatDate(end_date_and_time, "dateTimeLocal"),
    },
  });
  const onSubmit = ({ start_date_and_time, end_date_and_time }) => {
    getPrintDoc
      .mutateAsync({
        start_date_and_time: formatDate(start_date_and_time, "inputDateTime"),
        end_date_and_time: formatDate(end_date_and_time, "inputDateTime"),
      })
      .then((data) => {
        print([data]);
        onExit();
      });
  };

  return (
    <Modal width={{ _: "95%", sm: "50rem" }} onExit={onExit} {...props}>
      <form onSubmit={handleSubmit(onSubmit)} className="my-[3rem]">
        <div className="mb-[2rem]">
          <Textfield
            type="datetime-local"
            ref={register({
              required: {
                value: true,
                message: t("fieldRequired"),
              },
            })}
            name="start_date_and_time"
            error={errors?.start_date_and_time?.message}
            label={t("start_date_and_time")}
          />
        </div>
        <Textfield
          type="datetime-local"
          ref={register({
            required: {
              value: true,
              message: t("fieldRequired"),
            },
          })}
          name="end_date_and_time"
          error={errors?.end_date_and_time?.message}
          label={t("end_date_and_time")}
        />
        <div className="mt-8 flex gap-12">
          <div>
            <Button isPending={getPrintDoc.isPending}>{t("print")}</Button>
          </div>

          <Button onClick={onExit}>{t("cancel")}</Button>
        </div>
      </form>
    </Modal>
  );
};

export default SchedulesPrintModal;
